var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBlockOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22,7.5H2C1.7,7.5,1.5,7.3,1.5,7S1.7,6.5,2,6.5h20c0.3,0,0.5,0.2,0.5,0.5S22.3,7.5,22,7.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22,12.5H2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h20c0.3,0,0.5,0.2,0.5,0.5S22.3,12.5,22,12.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22,17.5H2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h20c0.3,0,0.5,0.2,0.5,0.5S22.3,17.5,22,17.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlockOrder);
export default __webpack_public_path__ + "static/media/icon-block-order.8cbbc1379ecc98444138be8fce11c924.svg";
export { ForwardRef as ReactComponent };